import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Redirect to the ERP standalone HTML app
    window.location.replace("/erp.html");
  }, []);
  return (
    <div
      data-testid="root-redirect"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, sans-serif",
        background: "#0D1B3E",
        color: "#C9A84C",
        fontSize: "18px",
        letterSpacing: "1px",
      }}
    >
      جاري تحميل نظام الجناح الملكي...
    </div>
  );
}

export default App;
